import api, { createApiService } from "../http"
import { ICbrRatesGosbank, ICbrRatesMetals } from "../types/services-types/cbr-types"

export default class CbrService {
    static apiCbrService = createApiService('/cbr')

    static async GetGosbankRates() {
        const response = await this.apiCbrService.get<ICbrRatesGosbank[]>('/rates-gosbank')
        return response.data
    }

    static async GetMetalsRates() {
        const response = await this.apiCbrService.get<ICbrRatesMetals[]>('/rates-metals')
        return response.data
    }
}